"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
const KEY = { tab: 9, enter: 13, esc: 27, up: 38, right: 39, down: 40 };
const STYLES = {
  wrapper: { position: "relative", display: "inline-block", direction: "ltr" },
  hint: {
    position: "absolute",
    top: 0,
    left: 0,
    borderColor: "transparent",
    boxShadow: "none",
    opacity: 1
  },
  input: {
    position: "relative",
    verticalAlign: "top",
    backgroundColor: "transparent"
  },
  dropdown: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: "auto",
    zIndex: 100
  },
  suggestions: { display: "block" },
  suggestion: { whiteSpace: "nowrap", cursor: "pointer" }
};
const HINT_BACKGROUND_PROPERTIES = [
  "backgroundAttachment",
  "backgroundClip",
  "backgroundColor",
  "backgroundImage",
  "backgroundOrigin",
  "backgroundPosition",
  "backgroundRepeat",
  "backgroundSize"
];
let lastId = 0;
function restingDisplay(props, item) {
  return props.display(item).replace(/<br>/g, " - ");
}
function normalizeQuery(query) {
  return query.replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
}
function escapeRegExp(text) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function suggestionHtml(html) {
  const suggestion = document.createElement("div");
  suggestion.innerHTML = html;
  Array.from(suggestion.children).forEach((child) => {
    child.style.whiteSpace = "normal";
  });
  return suggestion.innerHTML;
}
function withModifier(e) {
  return e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
}
function focused(props, e) {
  if (props.onFocus) {
    props.onFocus(e);
  }
}
function keyPress(props, state, e) {
  if (e.charCode === 13) {
    e.preventDefault();
    if (state.selectedItem && props.onSubmit) {
      props.onSubmit();
    }
  }
}
function stateFromProps(props) {
  const term = props.selectedItem ? restingDisplay(props, props.selectedItem) : "";
  return { term, query: term, selectedItem: props.selectedItem };
}
export default class TypeAhead extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", __spreadProps(__spreadValues({}, stateFromProps(this.props)), {
      isOpen: false,
      suggestions: null,
      cursor: -1,
      cursorByMouse: false,
      hint: "",
      hintBackground: {}
    }));
    __publicField(this, "id", `type-ahead-${++lastId}`);
    __publicField(this, "inputComponent", null);
    __publicField(this, "menu", null);
    __publicField(this, "searchId", 0);
    __publicField(this, "unmounted", false);
    __publicField(this, "termChanged", (value) => {
      this.setState({ term: value, selectedItem: null });
      if (value === "" && this.props.onClearSelectedItem) {
        this.props.onClearSelectedItem();
      }
      this.queryChanged(value);
    });
    __publicField(this, "dropped", (term) => {
      this.setState({ selectedItem: null, term });
      this.input().focus();
      this.queryChanged(term);
    });
    __publicField(this, "focused", (e) => {
      this.setState({ isOpen: true });
      focused(this.props, e);
    });
    __publicField(this, "blurred", () => {
      this.cancelSearch();
      this.setState({ suggestions: null });
      this.close(false);
    });
    __publicField(this, "keyDown", (e) => {
      const cursorItem = this.cursorItem();
      switch (e.keyCode) {
        case KEY.tab:
          if (withModifier(e)) {
            return;
          }
          if (cursorItem) {
            e.preventDefault();
            this.select(cursorItem);
          } else {
            if (this.state.hint && this.state.hint !== this.state.term) {
              e.preventDefault();
            }
            this.autocomplete();
          }
          return;
        case KEY.enter:
          if (cursorItem) {
            e.preventDefault();
            this.select(cursorItem);
          }
          return;
        case KEY.esc:
          this.close(true);
          return;
        case KEY.up:
        case KEY.down:
          if (!withModifier(e)) {
            e.preventDefault();
          }
          if (this.state.suggestions === null && this.state.query.length >= 1) {
            this.search(this.state.query);
          } else {
            this.moveCursor(e.keyCode === KEY.up ? -1 : 1);
          }
          this.setState({ isOpen: true });
          return;
        case KEY.right: {
          const input = this.input();
          if (input.selectionStart === input.value.length) {
            this.autocomplete();
          }
          return;
        }
      }
    });
  }
  componentDidMount() {
    const input = this.input();
    const inlineBackground = input.style.backgroundColor;
    input.style.backgroundColor = "";
    const style = window.getComputedStyle(input);
    const hintBackground = {};
    HINT_BACKGROUND_PROPERTIES.forEach((property) => {
      hintBackground[property] = style[property];
    });
    input.style.backgroundColor = inlineBackground;
    this.setState({ hintBackground });
    if (this.props.autoFocus) {
      window.setTimeout(() => {
        input.focus();
        input.select();
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedItem !== this.props.selectedItem && (this.props.selectedItem || null) !== (prevState.selectedItem || null)) {
      this.cancelSearch();
      this.setState(__spreadProps(__spreadValues({}, stateFromProps(this.props)), {
        isOpen: false,
        suggestions: null,
        cursor: -1
      }));
      return;
    }
    const hint = this.hint();
    if (hint !== this.state.hint) {
      this.setState({ hint });
    }
    if (this.state.cursor !== prevState.cursor && this.state.cursor >= 0 && !this.state.cursorByMouse) {
      this.scrollToCursor();
    }
  }
  componentWillUnmount() {
    this.unmounted = true;
  }
  input() {
    return ReactDOM.findDOMNode(this.inputComponent);
  }
  isMenuVisible() {
    return this.state.isOpen && this.state.suggestions !== null;
  }
  optionId(index) {
    return `${this.id}-option-${index}`;
  }
  // The rest of the top match's text, shown faintly after what was typed.
  hint() {
    const { term, suggestions, cursor, cursorByMouse } = this.state;
    if (!this.isMenuVisible() || !suggestions || suggestions.length === 0 || cursor >= 0 && !cursorByMouse || this.overflows()) {
      return "";
    }
    const match = new RegExp(
      "^(?:" + escapeRegExp(normalizeQuery(term)) + ")(.+$)",
      "i"
    ).exec(restingDisplay(this.props, suggestions[0].item));
    return match ? term + match[1] : "";
  }
  overflows() {
    const input = this.input();
    return input.scrollWidth > input.clientWidth || input.scrollHeight > input.clientHeight;
  }
  scrollToCursor() {
    const menu = this.menu;
    const option = document.getElementById(this.optionId(this.state.cursor));
    if (!menu || !option) {
      return;
    }
    const top = option.offsetTop - menu.scrollTop;
    const bottom = top + option.offsetHeight;
    if (top < 0) {
      menu.scrollTop += top;
    } else if (menu.clientHeight < bottom) {
      menu.scrollTop += bottom - menu.clientHeight;
    }
  }
  // Only the latest search's results are shown.
  search(query) {
    const searchId = ++this.searchId;
    const show = (items) => {
      if (this.unmounted || searchId !== this.searchId) {
        return;
      }
      this.setState({
        suggestions: (Array.isArray(items) ? items : []).map((item) => ({
          item,
          html: suggestionHtml(this.props.display(item))
        })),
        cursor: -1,
        cursorByMouse: false
      });
    };
    if (this.props.remoteSearch) {
      this.props.remoteSearch(query).then(show);
    } else {
      show(this.props.search(query));
    }
  }
  cancelSearch() {
    this.searchId++;
  }
  queryChanged(value) {
    const { query } = this.state;
    if (value === query) {
      return;
    }
    if (normalizeQuery(value) === normalizeQuery(query)) {
      this.setState({ query: value, isOpen: true });
      return;
    }
    if (value.length >= 1) {
      this.search(value);
      this.setState({ query: value, isOpen: true, cursor: -1 });
    } else {
      this.cancelSearch();
      this.setState({ query: value, isOpen: true, suggestions: null });
    }
  }
  select(item) {
    const value = restingDisplay(this.props, item);
    this.cancelSearch();
    this.setState({
      term: value,
      query: value,
      selectedItem: item,
      isOpen: false,
      suggestions: null,
      cursor: -1
    });
    if (this.props.onSelectItem) {
      this.props.onSelectItem(item);
    }
  }
  // Closing without a pick clears the field, so only picked items are kept.
  close(restoreQuery) {
    const { isOpen, selectedItem, query } = this.state;
    const clearing = isOpen && !selectedItem && !this.props.readOnly;
    const term = clearing && !restoreQuery ? "" : query;
    this.setState({ isOpen: false, cursor: -1, term, query: term });
    if (clearing && this.props.onClearSelectedItem) {
      this.props.onClearSelectedItem();
    }
  }
  moveCursor(increment) {
    const { isOpen, suggestions, cursor, query } = this.state;
    if (!isOpen || !suggestions) {
      return;
    }
    let next = (cursor + increment + 1) % (suggestions.length + 1) - 1;
    if (next < -1) {
      next = suggestions.length - 1;
    }
    this.setState({
      cursor: next,
      cursorByMouse: false,
      term: next === -1 ? query : restingDisplay(this.props, suggestions[next].item)
    });
  }
  cursorItem() {
    const { suggestions, cursor } = this.state;
    return suggestions && cursor >= 0 ? suggestions[cursor].item : null;
  }
  autocomplete() {
    const { hint, query, suggestions } = this.state;
    if (hint && query !== hint && suggestions && suggestions.length > 0) {
      this.select(suggestions[0].item);
    }
  }
  renderField() {
    const { readOnly, placeHolder, showTextArea, isDroppable } = this.props;
    const { term, cursor } = this.state;
    const fieldProps = {
      ref: (component) => {
        this.inputComponent = component;
      },
      disabled: readOnly,
      className: "carrier-setter__typeahead mousetrap-allow-text tt-input",
      placeholder: placeHolder,
      autoComplete: "off",
      spellCheck: false,
      dir: "auto",
      style: STYLES.input,
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": this.isMenuVisible(),
      "aria-owns": `${this.id}-listbox`,
      "aria-activedescendant": cursor >= 0 ? this.optionId(cursor) : void 0,
      onFocus: this.focused,
      onBlur: this.blurred,
      onKeyDown: this.keyDown,
      onKeyPress: (e) => keyPress(this.props, this.state, e)
    };
    if (isDroppable) {
      return /* @__PURE__ */ jsx(
        ValueLinkTextDroppableInput,
        __spreadProps(__spreadValues({
          "data-component": "TypeAhead",
          type: "text",
          typeahead: true
        }, fieldProps), {
          value: term,
          onValueChange: this.termChanged,
          inputDropped: this.dropped,
          showTextArea
        })
      );
    }
    const onChange = (e) => this.termChanged(e.target.value);
    if (showTextArea) {
      return /* @__PURE__ */ jsx("textarea", __spreadProps(__spreadValues({}, fieldProps), { value: term, onChange, rows: 1 }));
    }
    return /* @__PURE__ */ jsx("input", __spreadProps(__spreadValues({ type: "text" }, fieldProps), { value: term, onChange }));
  }
  renderHint() {
    const hintProps = {
      className: "carrier-setter__typeahead mousetrap-allow-text tt-hint",
      value: this.state.hint,
      readOnly: true,
      disabled: this.props.readOnly,
      tabIndex: -1,
      autoComplete: "off",
      spellCheck: false,
      "aria-hidden": true,
      style: __spreadValues(__spreadValues({}, STYLES.hint), this.state.hintBackground)
    };
    if (this.props.showTextArea) {
      return /* @__PURE__ */ jsx("textarea", __spreadProps(__spreadValues({}, hintProps), { rows: 1 }));
    }
    return /* @__PURE__ */ jsx("input", __spreadValues({ type: "text" }, hintProps));
  }
  renderSuggestions() {
    const { suggestions, cursor } = this.state;
    if (!suggestions) {
      return null;
    }
    return /* @__PURE__ */ jsxs(
      "span",
      {
        className: "tt-suggestions",
        id: `${this.id}-listbox`,
        role: "listbox",
        style: STYLES.suggestions,
        children: [
          suggestions.length === 0 && /* @__PURE__ */ jsx("div", { className: "tt-no-matches", children: "No matches found" }),
          suggestions.map((suggestion, index) => /* @__PURE__ */ jsx(
            "div",
            {
              id: this.optionId(index),
              role: "option",
              "aria-selected": index === cursor,
              className: "tt-suggestion" + (index === cursor ? " tt-cursor" : ""),
              style: STYLES.suggestion,
              onClick: () => this.select(suggestion.item),
              onMouseEnter: () => this.setState({ cursor: index, cursorByMouse: true }),
              onMouseLeave: () => this.setState({ cursor: -1 }),
              dangerouslySetInnerHTML: { __html: suggestion.html }
            },
            index
          ))
        ]
      }
    );
  }
  render() {
    return /* @__PURE__ */ jsxs("span", { className: "twitter-typeahead", style: STYLES.wrapper, children: [
      this.renderHint(),
      this.renderField(),
      /* @__PURE__ */ jsx(
        "span",
        {
          ref: (menu) => {
            this.menu = menu;
          },
          className: "tt-dropdown-menu",
          style: __spreadProps(__spreadValues({}, STYLES.dropdown), {
            display: this.isMenuVisible() ? "block" : "none"
          }),
          onMouseDown: (e) => e.preventDefault(),
          children: /* @__PURE__ */ jsx("div", { className: "tt-dataset-type-ahead", children: this.renderSuggestions() })
        }
      )
    ] });
  }
}
